import defaultTo from 'lodash/defaultTo';
import isNil from 'lodash/isNil';
import { useMemo } from 'react';

import { FilingFull, FilingType } from '../../graphql';

export type ConvertibleFilingTalkRanges = {
  couponTalkLow: number;
  couponTalkHigh: number;
  premiumTalkLow: number;
  premiumTalkHigh: number;
  priceAsOfPar: number;
} | null;

export function useConvertibleFilingTalkRanges(
  filings: Readonly<
    Pick<
      FilingFull,
      | 'filingType'
      | 'couponTalkLow'
      | 'couponTalkHigh'
      | 'premiumTalkLow'
      | 'premiumTalkHigh'
      | 'priceAsOfPar'
    >[]
  > | null
): ConvertibleFilingTalkRanges {
  return useMemo(() => {
    return getConvertibleFilingTalkRanges(filings);
  }, [filings]);
}

export function getConvertibleFilingTalkRanges(
  filings: Readonly<
    Pick<
      FilingFull,
      | 'filingType'
      | 'couponTalkLow'
      | 'couponTalkHigh'
      | 'premiumTalkLow'
      | 'premiumTalkHigh'
      | 'priceAsOfPar'
    >[]
  > | null
): ConvertibleFilingTalkRanges {
  const nonFinalFiling = filings?.filter(({ filingType }) => {
    return filingType !== FilingType.Final;
  });
  const latestFiling = nonFinalFiling?.[nonFinalFiling.length - 1];

  const { couponTalkLow, couponTalkHigh, premiumTalkLow, premiumTalkHigh, priceAsOfPar } =
    latestFiling ?? {};

  if (
    isNil(couponTalkLow) ||
    isNil(couponTalkHigh) ||
    isNil(premiumTalkLow) ||
    isNil(premiumTalkHigh)
  ) {
    return null;
  }

  return {
    couponTalkLow,
    couponTalkHigh,
    premiumTalkLow,
    premiumTalkHigh,
    priceAsOfPar: defaultTo(priceAsOfPar, 1),
  };
}
